import React from "react";
import Placeholder from "../../assets/images/placeholder.png";

function BannerPreviewModal({ show, onClose, title, description, image }) {
  if (!show) return null;

  return (
    <div className="banner-preview-modal-overlay" onClick={onClose}>
      <div className="banner-preview-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="banner-preview-modal-header">
          <h4>This is how it will look on Website</h4>
          <button type="button" className="banner-preview-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="banner-preview-modal-body">
          <div className="banner-preview-slide banner-preview-slide--modal">
            <div className="banner-preview-slide__content">
              <h2>{title || "Banner title will appear here"}</h2>
              <p>{description || "Banner description will appear here."}</p>
            </div>
            <div className="banner-preview-slide__image">
              <img
                src={image || Placeholder}
                alt={title || "Banner preview"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = Placeholder;
                }}
              />
            </div>
          </div>
          <div className="banner-preview-slider-dots" aria-hidden="true">
            <button type="button" className="active" />
            <button type="button" />
            <button type="button" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerPreviewModal;
